<template>
  <div class="fullIn-wrap-container">
    <van-nav-bar
      title="物流信息"
      left-arrow
      @click-left="goBack"
      :class="[
        'rewrite-am-navbar-light',
        not_iphonex ? 'notrem-rewrite-am-navbar-light-notiphonex' : '',
        iphonex && !not_iphonex ? 'notrem-rewrite-am-navbar-light-iphonex' : '',
      ]"
    />
    <div
      :class="[
        'fullIn-wrap',
        not_iphonex ? 'notrem-fullIn-wrap-notiphonex' : '',
        iphonex && !not_iphonex ? 'notrem-fullIn-wrap-iphonex' : '',
      ]"
    >
      <div class="card-box">
        <h4 class="card-box-title">
          <span>退回教材</span>
          <label class="badge">共{{ goodsName.length }}件</label>
        </h4>
        <div class="info-list-box1">
          <template v-for="(item, index) in goodsName">
            <p
              :key="index"
              v-if="index > 1"
              :style="{ display: infoSlideOpen ? 'block' : 'none' }"
            >
              教材{{ index + 1 }}:{{ item }}
            </p>
            <p :key="index" v-else style="display: block">
              教材{{ index + 1 }}:{{ item }}
            </p>
          </template>
          <p v-if="goodsName.length > 2">
            <span
              v-show="infoSlideOpen"
              class="silde-box"
              @click="infoSlideToggle"
              >收起<span class="silde-down-icon"></span
            ></span>
            <span
              v-show="!infoSlideOpen"
              class="silde-box"
              @click="infoSlideToggle"
              >展开<span class="silde-up-icon"></span
            ></span>
          </p>
        </div>
      </div>
      <div class="card-box" style="padding-top: 0; padding-bottom: 0">
        <!-- 快递表单组件 -->
        <ExpressFormComponent ref="expressFormComponent"></ExpressFormComponent>
      </div>
      <div class="card-box">
        <h4 class="card-box-title flex-between">
          <span>退回地址</span>
          <button
            class="copy-btn"
            id="copyBtn"
            :data-clipboard-text="
              returnName + '，' + returnPhone + '，' + returnAddress
            "
            @click="copyHandle"
          >
            <span class="copy-btn-icon"></span>复制
          </button>
        </h4>
        <div class="return-address-box">
          <h5 class="return-address-title">
            <span class="return-address-name">{{ returnName }}</span>
            <span>{{ returnPhone }}</span>
          </h5>
          <div class="info-list-box2">
            <p>{{ returnAddress }}</p>
          </div>
        </div>
      </div>
      <div class="card-box">
        <h4 class="card-box-title">
          <span>退回说明</span>
        </h4>
        <div class="info-list-box2">
          <p>1.退回前请联系班主任/顾问沟通确认退回原因</p>
          <p>2.请填写正确的快递公司与快递单号</p>
        </div>
      </div>
      <div class="footer-fixed-box">
        <div class="submit-btn" @click="submitReturnData">确认退回</div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapMutations } from "vuex";
import Clipboard from "clipboard";
import ExpressFormComponent from "./components/expressFormComponent";
import appUtil from "../../utils/appUtil";

export default {
  name: "logisticsDetail",
  data() {
    return {
      bizId: "",
      infoSlideOpen: false,
      goodsIds: [],
      goodsName: [],
      subject: "",
      returnName: "",
      returnPhone: "",
      returnAddress: "",
      clipboard: {},
      tab: "",
      not_iphonex: window.navigator.userAgent.includes("not_iphonex"),
      iphonex: window.navigator.userAgent.includes("iphonex"),
    };
  },
  components: {
    ExpressFormComponent,
  },
  computed: {},
  created() {
    let isApp = new appUtil().isApp();
    if (isApp == "android" || isApp == "ios") {
      window.dhsdk.isShowNavigation({
        show: false,
      });
    }
  },
  mounted() {
    this.bizId = this.$route.query.bizId ? this.$route.query.bizId : "";
    this.goodsIds = this.$route.query.goodsIds
      ? this.$route.query.goodsIds.split(",")
      : [];
    this.subject = this.$route.query.subject ? this.$route.query.subject : "";
    this.tab = this.$route.query.tab ? this.$route.query.tab : "";
    this.getSendBackChooses();
    this.getReturnAddress();
    window.scrollTo(0, 0);
  },
  methods: {
    ...mapMutations({
      changeLoading: "changeLoading",
    }),
    goBack() {
      window.location.replace(
        `${location.origin}${location.pathname}#/myPackage?tab=${this.tab}`
      );
    },
    //展开收起
    infoSlideToggle() {
      this.infoSlideOpen = !this.infoSlideOpen;
    },
    // 复制链接
    copyHandle() {
      let _this = this;
      let clipboard = new Clipboard("#copyBtn"); // 这里括号里填写上面点击事件绑定的class名
      clipboard.on("success", (e) => {
        e.clearSelection();
        // 复制成功，提示根据自己项目实际使用的UI来写
        _this.$toast("复制成功");
        // 释放内存
        clipboard.destroy();
      });
      clipboard.on("error", () => {
        // 不支持复制，提示根据自己项目实际使用的UI来写
        _this.$toast("复制失败，请重新尝试");
        // 释放内存
        clipboard.destroy();
      });
    },
    //提交
    submitReturnData() {
      let expressComponent = this.$refs.expressFormComponent;
      if (expressComponent.formValidator()) {
        //校验通过
        this.changeLoading(true);
        this.$api.my
          .returnInfoSubmit(
            {
              bizId: this.bizId,
              goodsIds: this.goodsIds,
              expressId: expressComponent.expressId.trim(),
              expressCompany: expressComponent.expressCompany,
              consignee: expressComponent.consignee,
              consigneePhone: expressComponent.consigneePhone,
            },
            { headers: { "Content-Type": "application/json" } }
          )
          .then((res) => {
            this.changeLoading(false);
            //埋点

            if (res.ret) {
              this.$toast("提交成功");
              setTimeout(() => {
                this.$router.replace({
                  path: "/returnDetail",
                  query: {
                    mrbNum: res.data.bizId,
                    tab: this.tab,
                  },
                });
                // window.location.replace(`${location.origin}/h5/mobile.html#/returnDetail?mrbNum=${res.data.bizId}&tab=${this.state.tab}`);
              }, 250);
            } else {
              this.$toast(res.msg);
            }
          });
      }
    },
    //获取收货地址
    getReturnAddress() {
      return new Promise((resolve) => {
        this.$api.my.getReturnAdress().then((res) => {
          if (res.ret) {
            this.returnName = res.data.consignee;
            this.returnPhone = res.data.consigneePhone;
            this.returnAddress = res.data.addressInfo;

            resolve(res.data);
          } else {
            this.$toast(res.msg);
          }
        });
      });
    },
    //获取所有教材
    getSendBackChooses() {
      return new Promise((resolve) => {
        this.$api.my
          .geSendBackChooses({
            bizId: this.bizId,
          })
          .then((res) => {
            if (res.ret) {
              if (res.data.goods.length > 0) {
                let selectGoodsList = res.data.goods.filter(
                  (item) => this.goodsIds.indexOf(item.id) != -1
                );

                let selectGoodsName = selectGoodsList.map((item) => item.name);
                this.goodsName = selectGoodsName;
              }
              resolve(res.data);
            } else {
              this.$toast(res.msg);
            }
          });
      });
    },
  },
};
</script>
<style lang="scss" scoped>
//退回信息填写
.fullIn-wrap-container {
  .fullIn-wrap {
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(51, 51, 51, 1);
    line-height: 15px;
    padding: 57px 12px 150px 12px;
    background: rgba(244, 244, 244, 1);
    min-height: 100%;
    .flex-between {
      justify-content: space-between;
      -webkit-box-pack: space-between;
      -webkit-justify-content: space-between;
      -ms-flex-pack: space-between;
    }
    .card-box {
      padding: 16px;
      background: rgba(255, 255, 255, 1);
      border-radius: 6px;
      &-title {
        font-size: 16px;
        line-height: 17px;
        display: flex;
        display: -webkit-box;
        display: -webkit-flex;
        display: -ms-flexbox;
        align-items: center;
        -webkit-box-align: center;
        -webkit-align-items: center;
        -ms-flex-align: center;
        margin-bottom: 16px;
        padding-bottom: 15px;
        border-bottom: 1px solid rgba(242, 242, 242, 1);
        .badge {
          margin-left: 10px;
          position: relative;
          font-size: 14px;
          color: rgba(153, 153, 153, 1);
          line-height: 15px;
        }
      }
    }
    .card-box + .card-box {
      margin-top: 12px;
    }
    .info-list-box1,
    .info-list-box2 {
      p {
        line-height: 20px;
        color: rgba(51, 51, 51, 1);
      }
      p + p {
        margin-top: 8px;
      }
    }
    .info-list-box2 {
      p {
        color: rgba(102, 102, 102, 1);
      }
    }
    .silde-box {
      display: flex;
      display: -webkit-box;
      display: -webkit-flex;
      display: -ms-flexbox;
      align-items: center;
      -webkit-box-align: center;
      -webkit-align-items: center;
      -ms-flex-align: center;
      color: rgba(102, 102, 102, 1);
      .silde-up-icon,
      .silde-down-icon {
        display: inline-block;
        width: 14px;
        height: 14px;
        background: url("../../assets/img/myPackage/arrow_lower_grey@2x.png")
          no-repeat right center;
        background-size: cover;
        margin-left: 4px;
      }
      .silde-down-icon {
        background: url("../../assets/img/myPackage/arrow_upper_grey@2x.png")
          no-repeat right center;
        background-size: cover;
      }
    }
    .return-address-box {
      .return-address-title {
        font-size: 16px;
        font-weight: 400;
        line-height: 20px;
        display: flex;
        display: -webkit-box;
        display: -webkit-flex;
        display: -ms-flexbox;
        align-items: center;
        -webkit-box-align: center;
        -webkit-align-items: center;
        -ms-flex-align: center;
        justify-content: space-between;
        -webkit-box-pack: space-between;
        -webkit-justify-content: space-between;
        -ms-flex-pack: space-between;
        margin-bottom: 8px;
        .return-address-name {
          font-weight: bold;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          flex: 1;
          -webkit-box-flex: 1;
          -webkit-flex: 1;
          -ms-flex: 1;
          margin-right: 3px;
        }
      }
    }
    .footer-fixed-box {
      position: fixed;
      width: 100%;
      left: 0;
      bottom: 0;
      background: rgba(255, 255, 255, 1);
      padding: 12px 20px 25px;
      .submit-btn {
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(255, 255, 255, 1);
        height: 44px;
        background: rgba(205, 0, 20, 1);
        border-radius: 4px;
        text-align: center;
        padding-top: 15px;
      }
    }
    .copy-btn {
      display: flex;
      display: -webkit-box;
      display: -webkit-flex;
      display: -ms-flexbox;
      align-items: center;
      -webkit-box-align: center;
      -webkit-align-items: center;
      -ms-flex-align: center;
      font-size: 11px;
      font-weight: 400;
      color: rgba(102, 102, 102, 1);
      line-height: 12px;
      background-color: #ffffff;
      .copy-btn-icon {
        display: inline-block;
        width: 14px;
        height: 14px;
        background: url("../../assets/img/myPackage/copy_icon@2x.png") no-repeat
          center;
        background-size: cover;
        margin-right: 4px;
      }
    }
  }
  .rewrite-am-navbar-light {
    color: #333;
    position: fixed;
    top: 0;
    right: 0;
    left: 0;
    z-index: 999;
    height: 44px;
    box-sizing: content-box;
    border-bottom: 1px solid #f3f3f3;
  }
  .notrem-fullIn-wrap-iphonex {
    padding-top: calc(1.173333rem + 40px + 0.4rem);
  }
  .notrem-fullIn-wrap-notiphonex {
    padding-top: calc(1.173333rem + 20px + 0.4rem);
  }
  .notrem-rewrite-am-navbar-light-iphonex {
    padding-top: 40px;
  }
  .notrem-rewrite-am-navbar-light-notiphonex {
    padding-top: 20px;
  }
}
</style>
